import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";

const STATS = [
  { label: "Projection", value: "2–3 m", desc: "The radius your fragrance commands in a room.", pct: 0.9 },
  { label: "Sillage", value: "Heavy", desc: "The trail left behind you — unmistakably yours.", pct: 0.95 },
  { label: "Longevity", value: "10–14 hrs", desc: "From first spray to the final skin-close whisper.", pct: 0.85 },
];

export default function PerformanceStats() {
  return (
    <section data-testid="performance-section" className="max-w-[1440px] mx-auto px-5 md:px-10 py-24 md:py-32">
      <Reveal>
        <p className="overline-label">Performance</p>
        <h2 className="font-serif-brand text-4xl md:text-5xl font-light mt-4">Crafted For Performance</h2>
      </Reveal>
      <div className="mt-16 grid md:grid-cols-3 gap-12 md:gap-8">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.12}>
            <div className="border-t border-black/15 pt-8">
              <div className="flex items-baseline justify-between">
                <h3 className="text-[0.7rem] uppercase tracking-[0.28em] font-medium">{s.label}</h3>
                <span className="font-serif-brand text-4xl md:text-5xl font-light text-[#BA8D53]">{s.value}</span>
              </div>
              <div className="mt-6 h-px bg-black/10 relative overflow-hidden">
                <motion.div
                  initial={{ scaleX: 0 }}
                  whileInView={{ scaleX: s.pct }}
                  viewport={{ once: true }}
                  transition={{ duration: 1.4, delay: 0.3 + i * 0.15, ease: [0.22, 1, 0.36, 1] }}
                  className="absolute inset-0 bg-[#BA8D53] origin-left"
                />
              </div>
              <p className="mt-5 text-sm text-black/55 leading-relaxed">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
